import { defineNuxtPlugin } from '#app'
import { RegleVuePlugin } from '@regle/core'

export default defineNuxtPlugin((nuxtApp) => {
  // Registra o plugin do Regle globalmente na instância do Vue
  nuxtApp.vueApp.use(RegleVuePlugin)
})